import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const EditIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path
      fillRule="evenodd"
      d="M10.924.519 2 9.444v3.537l3.536-.002 8.923-8.925L10.924.52ZM3.5 11.48h1.414l7.423-7.426-1.413-1.414L3.5 10.065v1.415Z M16 14.5H0V16h16v-1.5Z"
    />
  </IconWrapper>
)

export default EditIconSmall
